import React, { Fragment } from "react"
import { withTheme } from "emotion-theming"

import styled from "react-emotion"
import PropTypes from "prop-types"
import Color from "color"
import Icon from "./Icon"

const Button = props => {
    let backgroundColor = props.theme.buttonColor
    let fontColor = props.theme.buttonFontColor
    let borderColor = props.theme.buttonBorderColor

    if (props.color === "success") {
        backgroundColor = props.theme.successColor
    }
    if (props.color === "danger") {
        backgroundColor = props.theme.dangerColor
    }
    if (props.color === "brand") {
        backgroundColor = props.theme.brandColor
    }
    if (backgroundColor !== props.theme.buttonColor) {
        // We'll somehow need to change this to something smarter to work
        // out if we need to show borders for white/light buttons or
        // change the font to white if necessary
        borderColor = backgroundColor
        fontColor = "white"
    }
    if (props.color === "clear") {
        backgroundColor = "rgba(0,0,0,0)"
        borderColor = "rgba(0,0,0,0)"
    }
    const hoverColor = Color(backgroundColor)
        .darken(0.1)
        .string()
    var hoverFontColor;
    if (props.color === "success") {
        hoverFontColor = "white"
    } else {
        hoverFontColor = "#999"
    }

    var fontSize
    var defaultPadding
    switch (props.size) {
        case "small":
            fontSize = "fontS"
            defaultPadding = "small"
            break
        case "large":
            fontSize = "fontL"
            defaultPadding = "large"
            break
        default:
            fontSize = "fontM"
            defaultPadding = "medium"
    }

    const Button = styled("div")`
        cursor: pointer;
        user-select: none;
        tab-index: 0;

        display: inline-block;
        text-align: center;

        font-family: ${props => props.theme.fontFamily};
        font-size: ${props => props.theme[fontSize]};
        color: ${fontColor};

        background-color: ${backgroundColor};
        border-radius: ${props => (props.round ? "100%" : props.theme.buttonBorderRadius)};
        border: ${props => props.theme.buttonBorderThickness} solid ${borderColor};

        padding: ${props => props.theme[props.padding || defaultPadding]};
        margin: ${props => props.theme[props.margin || "small"]}
            ${props => (props.sideMargin ? props.theme[props.sideMargin] : "0px")};

        width: ${props => (props.width ? props.width : "unset")};

        ${props =>
            props.round &&
            `
        height: 30px;
        width: 30px;
        padding: 6px 9px;
        font-size: 17px;
        `} font-weight: bold;

        &:active {
            background-color: ${hoverColor};
            color: ${hoverFontColor};
        }

        ${props =>
            props.noRadius &&
            `
            border-radius: 0px;
            `};
    `
    let label = props.children || ""

    if (props.icon) {
        label = (
            <Fragment>
                <Icon margin="none" icon={props.icon} weight={props.iconWeight} />
                {label && <span style={{ width: 8, display: "inline-block" }} />}
                {label}
            </Fragment>
        )
    }

    return (
        <Button role="button" tabIndex={0} {...props}>
            {label}
        </Button>
    )
}
Button.displayName = "Button"

Button.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    margin: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    color: PropTypes.oneOf(["primary", "success", "danger", "clear"]),
}

export default withTheme(Button)



// WEBPACK FOOTER //
// ./src/ui/components/Button.js